import { FormControlLabel } from '@mui/material';
import { FormikProps } from 'formik';
import { FormikSwitch } from '../../../common/formik-material-ui';
import {
  trackToggledAssignToAgentOnAnswer,
  trackToggledIfOwnedOnlyDialFromOwner,
  trackToggledOverrideOwnerOnAnswer,
} from '../../../common/userTracking';

export function CrmOwnershipRules(props: { formik: FormikProps<any> }) {
  return (
    <>
      <div className="container">
        <div className="row borderBottom">
          <div className="col-lg-8">
            <h5 className="fieldTitle">Assign to Agent on Answer</h5>
            <p className="fieldDescription">
              When toggled ON, Kixie will automatically assign the Agent to be
              the Contact Owner in their connected CRM when the call is
              answered.
            </p>
          </div>
          <div className="col-lg-4">
            <FormControlLabel
              onClick={() => {
                trackToggledAssignToAgentOnAnswer();
              }}
              control={
                <FormikSwitch
                  handleChange={(_e) => {
                    props.formik.setFieldValue(
                      'assignToAgentOnAnswer',
                      !props.formik.values.assignToAgentOnAnswer
                    );
                    if (props.formik.values.assignToAgentOnAnswer) {
                      props.formik.setFieldValue(
                        'overrideOwnerOnAnswer',
                        false
                      );
                    }
                  }}
                  name="assignToAgentOnAnswer"
                  formik={props.formik}
                  color="primary"
                  type="checkbox"
                />
              }
              style={{
                minWidth: '100%',
                marginBottom: 0,
                marginTop: 5,
                paddingLeft: 5,
              }}
              label="Assign to Agent on Answer"
            />
          </div>
        </div>
        <div className="row borderBottom">
          <div className="col-lg-8">
            <h5 className="fieldTitle">Override Owner on Answer</h5>
            <p className="fieldDescription">
              When toggled ON, Kixie will change the Contact Owner to the
              current Agent in their connected CRM when the call is answered.
            </p>
          </div>
          <div className="col-lg-4">
            <FormControlLabel
              onClick={() => {
                trackToggledOverrideOwnerOnAnswer();
              }}
              control={
                <FormikSwitch
                  disabled={!props.formik.values.assignToAgentOnAnswer}
                  name="overrideOwnerOnAnswer"
                  formik={props.formik}
                  color="primary"
                  type="checkbox"
                />
              }
              style={{
                minWidth: '100%',
                marginBottom: 0,
                paddingLeft: 5,
              }}
              label="Override Owner on Answer"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <h5 className="fieldTitle">If Owned - Only Dial from Owner</h5>
            <p className="fieldDescription">
              If the Contact has an Owner in the connected CRM, only the
              Assigned Owner can call that Contact through this Powerlist.
            </p>
          </div>
          <div className="col-lg-4">
            <FormControlLabel
              onClick={() => {
                trackToggledIfOwnedOnlyDialFromOwner();
              }}
              control={
                <FormikSwitch
                  name="onlyDialFromOwnerIfOwned"
                  formik={props.formik}
                  color="primary"
                  type="checkbox"
                />
              }
              label="If Owned - Only Dial from Owner"
              style={{ paddingLeft: 5 }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
